<ca-error-page type="forbidden" [title]="title" [description]="description">
  <button class="btn btn-primary" (click)="onClick()">Log out</button>
</ca-error-page>
